import { PaymentButtonValues, PaymentCategoryType } from 'consts';
import { splitAmount } from 'helpers/commonHelper';
import withContext from 'hoc/withContext';
import React, { createRef, PureComponent, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';
import { IStatusBar } from 'types/Payment';

import PaymentNotification from '../paymentNotification/PaymentNotification';

import {
  Amount,
  AmountText,
  Animation,
  Container,
  Decimal,
  Integer,
  Item,
  ItemBold,
  LineBreak,
  OrderDescription,
} from './Statusbar.styles';
import PayButton from '../payButton/PayButton';

interface IState {
  button: RefObject<HTMLButtonElement>;
  focused: boolean;
  isLoading: boolean;
}

class StatusBar extends PureComponent<IStatusBar, IState> {
  constructor(props: IStatusBar) {
    super(props);
    this.state = {
      button: createRef<HTMLButtonElement>(),
      focused: false,
      isLoading: false,
    };
  }

  componentDidUpdate() {
    const { progress, isMobileOrTablet, paymentMethodType } = this.props;
    const { focused, button } = this.state;
    if (
      PaymentCategoryType.GOOGLE_PAY !== paymentMethodType &&
      PaymentCategoryType.APPLE_PAY !== paymentMethodType &&
      !focused &&
      !isMobileOrTablet &&
      progress === PaymentButtonValues.SHOW
    ) {
      button.current?.focus();
      this.setFocused();
    }
    this.setLoading(progress === PaymentButtonValues.LOADING);
  }

  showPaymentRedirectScreen = () => {
    const { showPaymentRedirectScreen } = this.props;
    if (showPaymentRedirectScreen) {
      showPaymentRedirectScreen();
    }
  };

  handleError = (error: Error) => {
    this.setState(() => {
      throw error;
    });
  };

  setLoading = (isLoading: boolean) => {
    this.setState({ isLoading });
  };

  setFocused = () => {
    this.setState({ focused: true });
  };

  render() {
    const { payment, progress, paymentMethodId, paymentId, paymentMethodType, showPaymentNotification } = this.props;
    const { isLoading } = this.state;

    if (!payment || Object.keys(payment).length === 0) {
      return false;
    }
    const { amount = 0, currency, description, shop = {}, buyer = {} } = payment;

    const { name: shopName } = shop;
    const { email: buyerEmail } = buyer;
    const { integers, decimals } = splitAmount(amount);
    const { button } = this.state;
    const isVisible = progress === PaymentButtonValues.SHOW && !isLoading;

    const paymentData = {
      payment,
      paymentId,
      paymentMethodId,
      paymentMethodType,
    };
    return (
      <Container className="statusbar__container">
        <Amount>
          <AmountText>
            <FormattedMessage id="statusBar.amountText" />
          </AmountText>
          <p>
            <Integer className="statusbar__integer">{integers}</Integer>
            <Decimal className="statusbar__decimal">{`,${decimals}${currency}`}</Decimal>
          </p>
        </Amount>
        <OrderDescription>
          <FormattedMessage id="statusBar.orderDescription" />
          <p className="statusbar__description">{description}</p>
        </OrderDescription>
        <PaymentNotification
          {...paymentData}
          showPaymentNotification={showPaymentNotification}
          progress={progress === undefined ? 0 : progress}
        />

        <PayButton
          {...paymentData}
          paymentButtonRef={button}
          handleError={this.handleError}
          setLoading={() => this.setLoading(true)}
          showPaymentNotification={showPaymentNotification}
          showPaymentRedirectScreen={this.showPaymentRedirectScreen}
        />

        <Animation
          isVisible={isVisible}
          showPaymentNotification={showPaymentNotification as boolean}
          progress={progress || 0}
        >
          <Item>
            <FormattedMessage id="statusBar.sellerText" />
          </Item>
          <ItemBold className="statusbar__shop-name">{shopName}</ItemBold>
          <LineBreak />
          <Item>
            <FormattedMessage id="statusBar.buyerText" />
          </Item>
          <ItemBold className="statusbar__buyer-email">{buyerEmail}</ItemBold>
        </Animation>
      </Container>
    );
  }
}

export default withContext(StatusBar);
